
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import stores from '@/stores';
import { mixin as Clickaway } from 'vue-clickaway';
import { SweetModal } from 'sweet-modal-vue';
import vPagination from '@/components/VuePlainPagination.vue';
import NevronSearch from '@/components/NevronSearch.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import _ from 'lodash';
import Skeleton from "@/modules/Skeleton.vue";
import {manageTranslate, translate} from "../../helpers/functions";

@Component({
  methods: {manageTranslate, translate},
  components: {
    Skeleton,
    SweetModal,
    vPagination,
    NevronSearch,
    NevronSearchNoResults,
  },
  mixins: [ Clickaway ],
})

export default class AttachDashboard extends Vue {
  searchQuery: string = '';
  response: any = null;
  items: any = null;
  selectedDashboards: number[] = [];
  allChecked = false;
  firstLoad = true;

  searchItems = _.debounce((res: any) => {
    this.fetchData();
  }, 400);

  mounted() {
    this.fetchData(1);
  }

  fetchData(index = 1): any {
    stores.dashboards.fetchData(index, this.searchQuery, 10, 'Mobile')
      .then((response) => {
        this.response = response;
        this.items = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @Watch('response.currentPage')
  changedPage(index: number) {
    if (this.firstLoad) {
      this.firstLoad = false;
      return;
    }
    this.fetchData(index);
  }

  toggleDashboard(id: number) {
    const index = this.selectedDashboards.indexOf(id);
    if (index > -1) {
      this.selectedDashboards.splice(index, 1);
    } else {
      this.selectedDashboards.push(id);
    }
    this.updateCheck();
  }

  checkAll() {
    if (!this.allChecked) {
      this.selectedDashboards = [];
      // @ts-ignore
      for (const dashboard of this.response.data) {
        if (dashboard.id) {
          this.selectedDashboards.push(dashboard.id);
        }
      }
      this.allChecked = true;
    } else {
      this.selectedDashboards = [];
      this.allChecked = false;
    }
  }

  updateCheck() {
    if (this.selectedDashboards.length === this.response.data.length) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }

  save() {
    if (this.selectedDashboards.length === 0) {
      return;
    }
    // Get full dashboard objects for selected IDs
    const selectedDashboardObjects = this.response.data.filter((d: any) =>
      this.selectedDashboards.includes(d.id)
    );
    this.$emit('save', selectedDashboardObjects);

    // Close modal and restore scroll
    this.selectedDashboards = [];
    this.allChecked = false;
    // @ts-ignore
    this.$children[0].close();
  }

  cancel() {
    this.selectedDashboards = [];
    this.allChecked = false;
    // @ts-ignore
    this.$children[0].close();
  }

  open() {
    // Ensure data is loaded when opening
    if (!this.response || !this.items) {
      this.fetchData(1);
    }
    // @ts-ignore
    this.$children[0].open();
  }

  close() {
    // @ts-ignore
    this.$children[0].close();
  }
}
